"use strict";

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};


//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/~/babel-runtime/helpers/classCallCheck.js
// module id = ../../../../babel-runtime/helpers/classCallCheck.js
// module chunks = 3